import request from '@/utils/request'


// 查询群聊列表
export function listCommunityChatGroup(query) {
  return request({
    url: '/community/admin/communit/chat/group/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询群聊分页
export function pageCommunityChatGroup(query) {
  return request({
    url: '/community/admin/community/chat/group/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询群聊详细
export function getCommunityChatGroup(data) {
  return request({
    url: '/community/admin/community/chat/group/detail',
    method: 'get',
    params: data
  })
}



// 修改群聊
export function updateCommunityChatGroup(data) {
  return request({
    url: '/community/admin/community/chat/group/edit',
    method: 'post',
    data: data
  })
}

// 删除群聊
export function delCommunityChatGroup(data) {
  return request({
    url: '/community/admin/community/chat/group/delete',
    method: 'post',
    data: data
  })
}